var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:{'multi-line-button' : _vm.multiLine},attrs:{"loading":_vm.value,"outlined":"","color":_vm.color,"width":"100%","disabled":_vm.disabled},on:{"click":_vm.openCustomerPortal}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t(_vm.message))+" ")]),_c('v-icon',{staticClass:"ml-2"},[_vm._v(" open_in_new ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }